const $ = require('jquery');
import { tns } from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', function () {
  const $controls = $('.main_slider .slider-tns__arrows');

  tns({
    container: '.slider-tns',
    mode: 'carousel',
    items: 1,
    controls: !!$controls[0],
    controlsContainer: $controls[0],
    nav: true,
    axis: 'horizontal',
    startIndex: 0,
    slideBy: 'page',
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    mouseDrag: false,
    lazyload: true,
  });
});
